<template>
  <el-checkbox 
    class="ACheckboxYN"
    v-model="val" 
    true-label="Y" false-label="N"
    :checked="checked"
    :disabled="disabled"
    @change="handleChange"
  ><slot></slot></el-checkbox>
</template>
<script>
export default {
  name: "ACheckboxYN",
  data() {
    return {
      val: "",
    };
  },
  props: {
    value: {
      required: true,
    },
    checked: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      this.val = val;
    }
  },
  created() {
    this.val = this.value;
  },
  methods: {
    handleChange() {
      this.$emit('input', arguments[0]);
      this.$emit('change', ...arguments);
    },
  },
}
</script>